import { MicroMoments } from '../models/micro-moments.interfaces';

export const RolloverMedallionQualificationMilesAppliedMocks: MicroMoments = {
  id: '',
  logo: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/moments/green-checkmark.svg',
    alt: 'Roll Over MQDs'
  },
  title: 'Selection Successful!',
  description: `You've successfully selected how you'd like to apply your Rollover MQMs. It can take up to 48 hours for your selection to post to your account.`,
  close: {
    path: '#',
    alt: 'close'
  },
  ariaLabel: {
    close: 'Close Micromoment'
  },
  disabled: false,
  loaded: true
};
